import { IconButton, Stack, Typography } from '@chronosphereio/chrono-ui';
import ChevronLeft from 'mdi-material-ui/ChevronLeft';
import ChevronRight from 'mdi-material-ui/ChevronRight';

interface ClusterPaginationProps {
  /** Zero-based. */
  page: number;
  total: number;
  onPageChange: (page: number) => void;
}

/** Step through clusters one at a time. Hides itself when there's nothing to page. */
export const ClusterPagination = ({ page, total, onPageChange }: ClusterPaginationProps) => {
  if (total <= 1) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton
        size="small"
        disabled={page <= 0}
        onClick={() => onPageChange(page - 1)}
        aria-label="Previous cluster"
      >
        <ChevronLeft fontSize="small" />
      </IconButton>
      <Typography variant="body2">
        {page + 1} of {total}
      </Typography>
      <IconButton
        size="small"
        disabled={page >= total - 1}
        onClick={() => onPageChange(page + 1)}
        aria-label="Next cluster"
      >
        <ChevronRight fontSize="small" />
      </IconButton>
    </Stack>
  );
};
